<template>
    <div class="astaFooter">
        <div class="info">
            <div>{{ store.antalObjekt }} träffar, sida {{ store.page }} av {{ Math.ceil(store.antalObjekt /
                store.settings.pageSize) }}
            </div>
            <div class="pagination-result-limit">
                <label class="ResultlimitLabel" for="AntalTräffarPerSida">Antal träffar per sida</label>
                <select class="resultlimit" id="AntalTräffarPerSida" aria-label="Antal träffar per sida"
                    @change="selectPageSize($event)">
                    <option value="10" :selected="store.settings.pageSize == 10">10</option>
                    <option value="25" :selected="store.settings.pageSize == 25">25</option>
                    <option value="50" :selected="store.settings.pageSize == 50">50</option>
                    <option value="100" :selected="store.settings.pageSize == 100">100</option>
                </select>
            </div>
        </div>
        <div class="paging SearchFoot" aria-label="Paginering">
            <ul class="paginator">
                <li v-if="store.page > 1">
                    <button name="pageselector" class="pagetext small" value="1" v-on:click="gotoPage(1)">
                        <Svgicon iconName="dubbelpil_vanster_mobil"></Svgicon>
                    </button>
                </li>
                <li v-if="store.page > 1">
                    <button name="pageselector" class="pagetext large" :value="store.page - 1"
                        v-on:click="gotoPage(store.page - 1)"
                        :aria-label="'Föregående: resultatsida ' + (store.page - 1)"
                        :title="'Föregående: resultatsida ' + (store.page - 1)">Föregående
                        sida</button>
                    <button name="pageselector" class="pagetext small" :value="store.page - 1"
                        v-on:click="gotoPage(store.page - 1)">
                        <Svgicon iconName="enkelpil_vanster_mobil"></Svgicon>
                    </button>
                </li>
                <li v-if="store.page != 1" class="desktoponly">
                    <button name="pageselector" class="pagenumber" value="1" aria-label="Gå till sida 1"
                        v-on:click="gotoPage(1)" title="Gå till sida 1">1</button>
                </li>
                <li v-if="store.page === 1">
                    <button name="pageselector" class="pagenumber currentpage" value="1" aria-label="Sida 1"
                        title="Sida 1">1</button>
                </li>
                <li v-if="store.page > 3" class="desktoponly">
                    <span>...</span>
                </li>
                <li v-for="p in pageSpan" :key="p" :class="{ 'desktoponly': store.page !== p }">
                    <button name="pageselector" class="pagenumber" :class="{ 'currentpage': store.page === p }"
                        :value="p" @click="gotoPage(p)" :aria-label="'Gå till sida ' + p"
                        :title="'Gå till sida ' + p">{{ p
                        }}</button>
                </li>
                <li v-if="store.page < Math.ceil(store.antalObjekt / store.settings.pageSize)">
                    <button name="pageselector" class="pagetext large" :value="store.page + 1"
                        @click="gotoPage(store.page + 1)" :aria-label="'Nästa: resultatsida ' + (store.page + 1)"
                        :title="'Nästa: resultatsida ' + (store.page + 1)">Nästa sida</button>
                    <button name="pageselector" class="pagetext small" :value="store.page + 1"
                        @click="gotoPage(store.page + 1)" aria-label="Gå till nästa sida">
                        <Svgicon iconName="enkelpil_hoger_mobil"></Svgicon>
                    </button>
                </li>
                <li v-if="store.page < Math.ceil(store.antalObjekt / store.settings.pageSize)">
                    <button name="pageselector" class="pagetext large"
                        :value="Math.ceil(store.antalObjekt / store.settings.pageSize)"
                        @click="gotoPage(Math.ceil(store.antalObjekt / store.settings.pageSize))"
                        :aria-label="'Nästa: resultatsida ' + (store.page + 1)"
                        :title="'Sista: resultatsida ' + (Math.ceil(store.antalObjekt / store.settings.pageSize))">Sista
                        sidan</button>
                    <button name="pageselector" class="pagetext small last" aria-label="Gå till sista sidan"
                        :value="Math.ceil(store.antalObjekt / store.settings.pageSize)"
                        @click="gotoPage(Math.ceil(store.antalObjekt / store.settings.pageSize))">
                        <Svgicon iconName="dubbelpil_hoger_mobil"></Svgicon>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import Svgicon from '../components/svgicon.vue';
import useAstaStore from '../stores/AstaStore';
const store = useAstaStore();

function selectPageSize(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;
    const pageSize = parseInt(value, 10);
    store.setPageSize(pageSize);
}
function gotoPage(page: number) {
    store.setPageNumber(page);
}

const pageSpan = computed<number[]>(() => {
    const totalPages = Math.ceil(store.antalObjekt / store.settings.pageSize);
    if (store.page === 1) {
        return [store.page, store.page + 1, store.page + 2].filter(p => p > 1 && p <= totalPages);
    } else if (store.page === 2) {
        return [store.page - 1, store.page, store.page + 1].filter(p => p > 1 && p <= totalPages);
    } else if (store.page === 3) {
        return [store.page - 2, store.page - 1, store.page].filter(p => p > 1 && p <= totalPages);
    } else {
        return [store.page - 1, store.page, store.page + 1].filter(p => p > 1 && p <= totalPages);
    }
});

</script>